import React from 'react';
import { format } from 'date-fns';
import { withStyles } from '@material-ui/core';
import appConstants from '../../../../appConstants';

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 16,
    color: theme.HeaderSelectedText,
    fontSize: 14,
    fontWeight: 600,
    '& span:not(:last-child)': {
      marginRight: 16
    }
  }
});

const TrailerDetailsHeader = ({ trailerDetails, classes }) => {
  if (!trailerDetails) return null;
  const { trailerNumber, ibeta } = trailerDetails;
  const formattedIbeta = ibeta ? format(ibeta, appConstants.DATETYPES.DATETIME.format) : 'N/A';
  return (
    <div className={classes.container}>
      <span>Trailer#: {trailerNumber}</span>
      <span>IBETA: {formattedIbeta}</span>
    </div>
  );
};

export default withStyles(styles)(TrailerDetailsHeader);
